import { Injectable } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AssetUrlInterceptor {
  private baseHref: string;

  constructor(
    @Inject(APP_BASE_HREF) baseHref: string,
    private sanitizer: DomSanitizer
  ) {
    // Normaliza o baseHref para garantir o formato correto
    this.baseHref = baseHref.endsWith('/') ? baseHref : `${baseHref}/`;
    if (this.baseHref === '/') {
      this.baseHref = '';
    }
  }

  /**
   * Intercepta e corrige URLs de imagens para garantir que funcionem com o baseHref
   * @param url URL original da imagem (ex: /images/face.svg)
   * @returns URL corrigida com baseHref quando necessário
   */
  adjustAssetUrl(url: string): string {
    if (!url || url.startsWith('http') || url.startsWith('data:') || url.startsWith('blob:')) {
      return url;
    }

    // Garante que a URL comece com '/'
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    
    // Se a URL já começa com o baseHref, não modifique
    if (this.baseHref && normalizedUrl.startsWith(this.baseHref)) {
      return normalizedUrl;
    }
    
    // Combina o baseHref com a URL
    return `${this.baseHref}${normalizedUrl.substring(1)}`;
  }

  /**
   * Retorna uma URL segura para uso em atributos [src]
   */
  getSafeUrl(url: string): any {
    const adjustedUrl = this.adjustAssetUrl(url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(adjustedUrl);
  }
}
